export {
  provideLocalization,
  resolveLocalization,
  useLocalization,
} from './use-localization'
